import cookie from "./_cookie";
import {productblockHandler} from "./productblock";
import Slider from "./_slider";

const recent = document.querySelector('.js-get-recently');

if (recent) {
    async function fetchProducts() {
        const currentProducts = cookie.get('recently-viewed')?.split(',') || [];

        if(currentProducts.length > 0) {
            document.querySelector('.js-get-recently-viewed').classList.remove('d-none');
        }

        if(currentProducts.length < 5) {
            [...recent.parentElement.children].map((element) => {
                if(element.classList.contains('js-slider-prev') || element.classList.contains('js-slider-next')) {
                    element.remove();
                }
            })
        }

        let counter = 0;
        for (const currentProduct of currentProducts) {
            if (counter >= 8) break;
            
            // Skip order protection products
            if (currentProduct.includes('order-protection')) {
                continue;
            }
            
            try {
                const response = await fetch(`${Shopify.routes.root}products/${currentProduct}?section_id=product-block-by-id`);
                const html = await response.text();

                const parser = new DOMParser();
                const doc = parser.parseFromString(html, 'text/html');
                const productData = doc.querySelector('.js-product-data');

                if(productData) {
                    window.dispatchEvent(new Event('slider.updated'));
                    recent.insertAdjacentHTML('beforeend', productData.innerHTML);
                    counter++;
                }
            } catch (error) {
                console.error(error);
            }
        }

    }

    fetchProducts().then(() => {
        const loadedRecentProducts = document.querySelector('.js-get-recently');

        loadedRecentProducts.childNodes.forEach(function(productBlock) {
          console.log(productBlock);
            if (productBlock.nodeType === 1) {
                productblockHandler(productBlock);
            }
        });
    }).then(() => {
        const sliderElement = document.querySelector('.js-get-recently-viewed').querySelector('.js-slider-delayed');
        const slider = new Slider(sliderElement);
    });

}

export const recentProducts = (newProduct, max, days) => {
    // Skip order protection products
    if (newProduct.includes('order-protection')) {
        return;
    }

    let currentProducts = cookie.get('recently-viewed');

    if (currentProducts && currentProducts !== ''){

        const products = currentProducts.split(',');
        var index = products.indexOf(newProduct);

        if (index !== -1) {
            products.splice(index, 1);
        }

        products.unshift(newProduct);
        products.slice(0, 10);
        cookie.set('recently-viewed', products, 14);

    } else {
        cookie.set('recently-viewed', newProduct, 14);
    }
}
